<template>
  <div class="notes-list">
    <NoteAdder :commentsMode="commentsMode" :entityType="entityType" :entityId="entityId" v-if="recentFirst" />
    <Note :key="note.id" v-for="note in notes" :note="note" :commentsMode="commentsMode" />
    <NoteAdder :commentsMode="commentsMode" :entityType="entityType" :entityId="entityId" v-if="!recentFirst" />
  </div>
</template>

<script>
 import NoteAdder from './NoteAdder';
 import Note from './Note';
 export default {
   props: [
     'entityType',
     'entityId',
     'recentFirst',
     'commentsMode',
   ],
   components: {
     NoteAdder,
     Note,
   },
   computed: {
     notes() {
       return this.recentFirst ?
              this.$store.state.notes.slice().reverse() :
              this.$store.state.notes;
     }
   }
 };
</script>



// WEBPACK FOOTER //
// assets/js/components/NoteList.vue